import React, { useCallback } from 'react';

import { cn } from '@lyearn/style';
import { Editor } from '@/components/Editor';

import { FormEditorProps } from './types';

function FormEditor({
  text,
  medias,
  setFieldValue,
  textFieldKey,
  mediasFieldKey,
  isTextAndMediaIndependent,
  placeholder,
  className,
  variant = 'body-short-01',
  editorOptions,
  disabled,
}: FormEditorProps) {
  const onChangeText = useCallback(
    (nextValue: string) => {
      setFieldValue(
        textFieldKey,
        isTextAndMediaIndependent ? nextValue : { text: nextValue, medias },
        true,
      );
    },
    [isTextAndMediaIndependent, medias, setFieldValue, textFieldKey],
  );
  const onChangeMedias = useCallback(
    (nextValue: any[]) => {
      if (mediasFieldKey)
        setFieldValue(
          mediasFieldKey,
          isTextAndMediaIndependent ? nextValue : { text, medias: nextValue },
          true,
        );
    },
    [mediasFieldKey, setFieldValue, isTextAndMediaIndependent, text],
  );

  return (
    <Editor
      className={cn('rounded-8 border border-field', className)}
      disabled={disabled}
      editorOptions={editorOptions}
      medias={medias}
      placeholder={placeholder}
      value={text}
      variant={variant}
      onChangeMedias={mediasFieldKey ? onChangeMedias : undefined}
      onChangeText={onChangeText}
    />
  );
}

export default React.memo(FormEditor);
